import type { Entitlement } from '@frontegg/react';
import { FronteggFeatureKeys } from './userEntitlementsContext.types';

/** Legacy and migrated Frontegg keys that grant pro-plan capabilities. */
export const PRO_PLAN_FEATURE_KEYS = [
  FronteggFeatureKeys.ProPlan,
  FronteggFeatureKeys.PremiumPlan,
] as const;

/** Legacy and migrated Frontegg keys that grant pro-plan subscription capabilities. */
export const PRO_PLAN_SUBSCRIPTION_FEATURE_KEYS = [
  FronteggFeatureKeys.ProPlanSubscription,
  FronteggFeatureKeys.PremiumPlanSubscription,
] as const;

export function isProPlanFeatureKey(featureKey: string): boolean {
  return (PRO_PLAN_FEATURE_KEYS as readonly string[]).includes(featureKey);
}

export function isProPlanSubscriptionFeatureKey(featureKey: string): boolean {
  return (PRO_PLAN_SUBSCRIPTION_FEATURE_KEYS as readonly string[]).includes(
    featureKey,
  );
}

export function getAnyFeatureEntitlement(
  getFeatureEntitlement: (featureKey: FronteggFeatureKeys) => Entitlement,
  featureKeys: readonly FronteggFeatureKeys[],
): Entitlement {
  for (const featureKey of featureKeys) {
    const entitlement = getFeatureEntitlement(featureKey);
    if (entitlement.isEntitled) {
      return entitlement;
    }
  }

  return {
    isEntitled: false,
    justification: undefined,
  };
}

export function isEntitledToResolvedFeatureKey(
  isEntitledTo: (request: { featureKey: string }) => Entitlement,
  featureKey: string,
): boolean {
  if (isProPlanFeatureKey(featureKey)) {
    return PRO_PLAN_FEATURE_KEYS.some(
      (key) => isEntitledTo({ featureKey: key }).isEntitled,
    );
  }

  if (isProPlanSubscriptionFeatureKey(featureKey)) {
    return PRO_PLAN_SUBSCRIPTION_FEATURE_KEYS.some(
      (key) => isEntitledTo({ featureKey: key }).isEntitled,
    );
  }

  return isEntitledTo({ featureKey }).isEntitled;
}
